import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import Styles from "./formDropdown.lit.scss";
import {FormInputElement} from "./formInputElement";
import {DROPDOWN_EVENT, type DropdownEvent} from "../../../page/elements/input/inputEvents";
import type {Maybe} from "../../../bootstrap/common/types";
import {type DataSelectOption, EopDropdown} from "../../../page/elements/input/dropdown";

@customElement("eop-form-dropdown")
export class EopFormDropdown extends FormInputElement<string> {

    public static readonly styles = Styles;

    @property({attribute: "label"})
    public label: string;
    @property({attribute: "placeholder"})
    public placeholder: string;
    @property({attribute: "options", type: Array})
    public options: DataSelectOption[] = [];
    @query("eop-dropdown")
    private dropdown: EopDropdown;

    public constructor() {
        super("");
        this.addEventListener(DROPDOWN_EVENT, (event: Event) => {
            event.stopPropagation();
            const eventDetails = (event as DropdownEvent).detail;
            this.select(eventDetails.value);
        });
    }

    public render(): TemplateResult {
        return html`
            <div class="input-element ${this.basicClassMap()}">
                <label for=${this.formUUId} aria-label=${this.label} @click=${this.preventLabelDefaultAction}>
                    <span class="label-text">${this.label}</span>
                    ${this.labelSuffix()}
                    ${this.renderValidationIcon()}
                </label>
                <eop-dropdown
                        .formUUId=${this.formUUId}
                        .inputId=${this.getFullId()}
                        .value=${this.value}
                        .placeholder=${this.placeholder}
                        .options=${this.options}
                        ?required=${this.required}
                        ?invalid=${this.isInErrorState()}
                        ?valid=${this.isInValidState()}
                        ?warning=${this.isInWarningState()}
                ></eop-dropdown>
            </div>
            ${this.renderValidationMessages()}
        `;
    }

    public focusInput(): void {
        this.dropdown.focusInput();
    }

    protected preset(): Maybe<string> {
        return this.options
            .findFirst(option => option.preset)
            ?.value;
    }

    protected valueEnhancements(inputValue: string): Map<string, string> {
        return new Map([["label", this.descriptorForValue(inputValue)]]);
    }

    private descriptorForValue(value: string): string {
        return this.options
                .findFirst(option => value === option.value)
                ?.label
            ?? this.placeholder
            ?? "";
    }

    private select(value: string): void {
        this.updateValue(value);
    }
}